import React, {Component} from "react"
import PropTypes from "prop-types"

import History from "@irati/utils/history"
import Flex from "@irati/ui/src/Flex"
import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {adminDashboardTracking} from "@irati-tracking/admin"
import workosService from "@irati/workos/services/workos"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"

import SendInvitesModal from "../SendInvitesModal"
import {SETTINGS_LOGIN_INTEGRATION} from "../../../routes/routeConfig"
import RadialPercentage from "../../RadialPercentage"

interface State {
  load: Promise<void> | null,
  singleSignOnEnabled: boolean,
  directorySyncEnabled: boolean
}

interface Props extends InjectIntl{
  percentage: number
}

class ActivationRate extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    load: null,
    singleSignOnEnabled: false,
    directorySyncEnabled: false
  }
  sendInvitesModal = React.createRef<any>()

  componentDidMount() {
    const load = workosService.getOrganisation(authentication.business().uuid).then((organisation) => {
      this.setState({
        singleSignOnEnabled: !!organisation?.connectionId,
        directorySyncEnabled: !!organisation?.directoryId
      })
    })
    this.setState({load})
  }

  handleClick = () => {
    adminDashboardTracking.openSendInviteModule()
    this.sendInvitesModal.current.show()
  }

  handleLink = () => {
    History.push({pathname: SETTINGS_LOGIN_INTEGRATION}, this.context)
  }

  render(){
    const {percentage, formatMessage} = this.props
    const {load, singleSignOnEnabled, directorySyncEnabled} = this.state
    const activationRate = Math.round(percentage)


    return <Loading load={load}>
      <Flex position="relative" marginBottom={2} id="adminSection_activationRate">
        <RadialPercentage value={percentage} />
        <div>
          <H3 marginLeft={3} marginBottom={1}>{formatMessage({id: "admin.components.activationRate.title"})}</H3>
          {activationRate < 100 && <>
            <Body
              marginLeft={3}
              marginRight={3}>
              {formatMessage({id: "admin.components.activationRate.paragraph.case1"})}
            </Body>
            <Button
              primary
              marginLeft={3}
              marginTop={3}
              marginBottom={1}
              onClick={this.handleClick}>
              {formatMessage({id: "admin.components.activationRate.button"})}
            </Button></>}
          {activationRate === 100 && (!singleSignOnEnabled || !directorySyncEnabled) && <>
            <Body
              small
              marginLeft={3}
              marginRight={3}>
              {formatMessage({id: "admin.components.activationRate.paragraph.case2"})}
            </Body>
            <Button
              primary
              marginLeft={3}
              marginTop={2}
              onClick={this.handleLink}>
              {formatMessage({id: "admin.containers.integrations.startIntegration.button"})}
            </Button></>}
          {activationRate === 100 && singleSignOnEnabled && directorySyncEnabled &&
            <Body
              marginLeft={3}
              marginRight={3}
              marginTop={3}>
              {formatMessage({id: "admin.components.activationRate.paragraph.case3"})}
            </Body>}
        </div>
      </Flex>
      <SendInvitesModal ref={this.sendInvitesModal} />
    </Loading>
  }
}

export default injectIntl(ActivationRate)
